export default __webpack_public_path__ + "static/media/Close.a29b5dc2.svg";